import { render, staticRenderFns } from "./LuxuryPropertiesForRent.vue?vue&type=template&id=4818c8bf&scoped=true&"
import script from "./LuxuryPropertiesForRent.vue?vue&type=script&lang=ts&"
export * from "./LuxuryPropertiesForRent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4818c8bf",
  null
  
)

export default component.exports